<template>
  <b-row>
    <b-card-group class="mb-12 col-md-12">
      <b-card header="Calendario de citas">
        <b-row class="form-group">
          <b-col sm="12">
            <div class="pull-right">
              <button @click="schedule()" class="btn btn-primary">
                <i class="fa fa-clock-o" /> Programar
              </button>&nbsp;
              <button @click="openAppointment()" class="btn btn-primary">
                <i class="fa fa-calendar" /> Agregar citas
              </button>&nbsp;
              <button @click="openTrucks()" class="btn btn-primary">
                <i class="fa fa-truck" /> Camiones no disponibles
              </button>&nbsp;
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="12">
            <table class="table table-striped table-bordered table-sm">
              <thead>
                <tr>
                  <td rowspan="2" align="center">
                    <button class="btn btn-primary btn-sm" @click="moveDays(-1)">
                      <i class="fa fa-chevron-left"></i>
                    </button>&nbsp;
                    <button class="btn btn-primary btn-sm" @click="moveDays(1)">
                      <i class="fa fa-chevron-right"></i>
                    </button>
                  </td>
                </tr>
                <tr>
                  <td
                    v-for="(day, k) in days"
                    :key="`h-${k}`"
                    scope="col"
                    align="center"
                    style="font-size: 18px; width: 150px;"
                  >{{day.locale('es').format("ddd DD, MMMM")}}</td>
                </tr>
              </thead>
              <tbody>
                <!-- <tr v-if="loading">
                  <td colspan="6" align="center">
                    <i class="fa fa-lg fa-spinner fa-spin"></i>
                  </td>
                </tr>-->
                <tr v-for="(hour,index) in hours" :key="index">
                  <td
                    scope="row"
                    align="center"
                    style="font-size: 18px; width: 150px;"
                  >{{`${hour.format('HH:00')}`}}</td>

                  <td v-for="(day, k) in days" :key="`b-${k}`">
                    <h4
                      v-if="hasPortages(day, hour)"
                      @click="displayAppointments(getAppointmentBySchedule(day, hour).requeriments, day, hour)"
                      style="cursor: pointer;"
                    >
                      <span
                        :class="`badge ${getAppointmentBySchedule(day, hour).total > 0 ? 'badge-success' : 'badge-primary'}`"
                      >{{ getAppointmentBySchedule(day, hour).assigned.length }} / {{ getAppointmentBySchedule(day, hour).total }}</span>
                    </h4>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </b-card>
    </b-card-group>

    <ModalAddAppointments
      :showModalAppointments="showModalAppointments"
      :specialChargeTypes="specialChargeTypes"
      :addAppointments="addAppointments"
      :port="port"
      :serviceSelected="serviceSelected"
      @close="showModalAppointments = false"
    />
    <ModalAssignment
      :showModalAssignment="showModalAssignment"
      :port="port"
      :makeAssignment="makeAssignment"
      :trucks="trucks"
      @close="showModalAssignment = false"
    />
    <ModalTrucks
      :showModalTrucks="showModalTrucks"
      :updateTrucks="updateTrucks"
      :trucks="trucks"
      @close="showModalTrucks = false"
    />
    <ModalEditAppointments
      :showAppointments="showAppointments"
      :requeriments="edit_requeriments"
      :addAppointments="addAppointments"
      :editAppointment="editAppointment"
      :removeAppointment="removeAppointment"
      :specialChargeTypes="specialChargeTypes"
      :port="port"
      :trucks="trucks"
      :serviceSelected="serviceSelected"
      :appointment_startdate="appointment_startdate"
      :appointment_enddate="appointment_enddate"
      @close="showAppointments = false"
    />
    <div
      v-if="showModalAppointments || showAppointments || showModalAssignment || showModalTrucks"
      class="modal-backdrop fade show"
    ></div>
  </b-row>
</template>

<script>
import api from "@/helpers/api";
import moment, { calendarFormat } from "moment";
import ModalAssignment from "@/views/portages/ModalAssignment";
import ModalTrucks from "@/views/portages/ModalTrucks";
import ModalAddAppointments from "@/views/portages/ModalAddAppointments";
import ModalEditAppointments from "@/views/portages/ModalEditAppointments";
export default {
  name: "Calendar",
  props: ["port", "serviceSelected", "portages"],
  components: {
    ModalAddAppointments,
    ModalEditAppointments,
    ModalAssignment,
    ModalTrucks
  },
  data() {
    return {
      days: [],
      hours: [],
      breaks: [],
      startHour: moment().startOf("day"),
      endHour: moment().endOf("day"),
      startDay: moment().add(-2, "d"),
      endDay: moment().add(2, "d"),
      appointment_startdate: null,
      appointment_enddate: null,
      showModalAppointments: false,
      showModalAssignment: false,
      showAppointments: false,
      showModalTrucks: false,
      specialChargeTypes: [],
      requeriments: [],
      trucks: [],
      edit_requeriments: [],
      loading: true
    };
  },
  mounted() {
    const { endDay, startDay, startHour, endHour, port } = this;
    // this.breaks = port.break.split(',')
    // console.log(this.breaks)

    let day = startDay;
    while (day <= endDay) {
      this.days.push(day);
      day = day.clone().add(1, "d");
    }

    let hour = startHour;
    while (hour <= endHour) {
      this.hours.push(hour);
      hour = hour.clone().add(1, "hour");
    }

    api.get("/charge_types").then(response => {
      this.specialChargeTypes = response.charge_types.filter(s => s.portage);
    });
    this.getTrucks();
  },
  watch: {
    port: function(newVal, oldVal) {
      this.getAppointments();
    },
    serviceSelected: function(newVal, oldVal) {
      this.getAppointments();
    }
  },
  methods: {
    moveDays(qty) {
      let { startDay, endDay } = this;

      let day = startDay.clone().add(qty, "d");
      this.startDay = day;
      this.endDay = endDay.clone().add(qty, "d");
      this.days = [];

      while (day.format("YYYY-MM-DD") <= this.endDay.format("YYYY-MM-DD")) {
        this.days.push(day);
        day = day.clone().add(1, "d");
      }
      this.getAppointments();
    },
    getTrucks() {
      api.get("/portage_trucks").then(response => {
        this.trucks = response.trucks;
      });
    },
    showWarning(label, title) {
      this.$toastr.warning(label, title, {
        positionClass: "toast-top-center",
        closeButton: true
      });
    },
    showSuccess(label, title) {
      this.$toastr.success(label, title, {
        positionClass: "toast-top-center",
        closeButton: true
      });
    },
    formatDateTime(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    openAppointment() {
      this.showModalAppointments = true;
    },
    openTrucks() {
      this.showModalTrucks = true;
    },
    updateTrucks(data) {
      console.log(data);
      api.post("/active_portage_trucks", data).then(response => {
        console.log(response);
        if (response.success) {
          this.$socket.emit("updatePortageTruckServer");
          this.showSuccess(
            "Lista de camiones disponibles actualizada.",
            "Camiones"
          );
        }
      });
    },
    editAppointment(requeriment) {
      requeriment.truck_id = requeriment.truck ? requeriment.truck.id : null;
      const data = { ...requeriment };
      delete data.appointments;
      let portage_charge_type = this.portages.filter(portage => {
        return portage.requeriments.some(
          rq => rq.charge_type_id === data.charge_type_id
        );
      });

      if (!portage_charge_type.length) {
        this.$toastr.warning(
          "No existen operaciones que requieran realizar movimientos con el tipo de carga indicado.",
          "Citas",
          {
            positionClass: "toast-top-center",
            closeButton: true
          }
        );
        return;
      }

      api.put(`/appointment/${requeriment.id}`, data).then(response => {
        let index = this.requeriments.findIndex(rq => rq.id == requeriment.id);
        // this.appointments.splice(index, 1, response.appointment)
        this.requeriments[index] = response.requeriment;

        this.$socket.emit("updateAppointmentServer", response.requeriment);

        this.$toastr.success("Cita actualizada", "Cita", {
          positionClass: "toast-top-center",
          closeButton: true
        });
      });
    },
    addAppointments(data) {
      console.log(data);

      // Validacion cantidad de citas
      if (data.qty < 0) {
        this.showWarning(
          "Cantidad de citas inválida. Ingrese un número válido.",
          "Citas"
        );
        return;
      }
      //Validacion tipo de carga
      let portage_charge_type = this.portages.filter(portage => {
        return portage.requeriments.some(
          rq => rq.charge_type_id === data.charge_type_id
        );
      });

      // Validacion por fecha de cita
      let start_schedule = data.appointment_startdate;
      let check_date = true;
      while (start_schedule <= data.appointment_enddate && check_date) {
        let day = moment(start_schedule);
        let hour = moment(start_schedule);
        check_date = this.hasPortages(day, hour);
        start_schedule = moment(start_schedule)
          .add(1, "hour")
          .format("YYYY-MM-DD HH:00:00");
      }

      if (!portage_charge_type.length) {
        this.showWarning(
          "No existen operaciones que requieran realizar movimientos con el tipo de carga indicado.",
          "Citas"
        );
        return;
      }

      if (!check_date) {
        this.showWarning(
          "No existen operaciones para ejecutar movimientos en el rango de fechas de citas indicado.",
          "Citas"
        );
        return;
      }

      api.post("/appointments", data).then(
        response => {
          response.requeriments.map(elem => {
            this.requeriments.push(elem);
          });
          this.$socket.emit("addAppointmentServer", response.requeriments);
          this.showSuccess(response.message, "Citas");
        },
        error => {
          this.showWarning(error.message, "Citas");
        }
      );
    },
    removeAppointment(requeriment) {
      let index = this.requeriments.findIndex(rq => rq.id === requeriment.id);
      this.requeriments.splice(index, 1);
    },
    getAppointmentBySchedule(day, hour) {
      let schedule_start = `${day.format("YYYY-MM-DD")} ${hour.format(
        "HH:00:00"
      )}`;
      let schedule_end = `${day.format("YYYY-MM-DD")} ${hour.format(
        "HH:59:59"
      )}`;
      let cal_startschedule = moment(schedule_start).format(
        "YYYY-MM-DD HH:00:00"
      );
      let cal_endschedule = moment(schedule_end).format("YYYY-MM-DD HH:59:59");
      const requeriments = this.requeriments.filter(rq => {
        return (
          rq.appointments[0].schedule >= cal_startschedule &&
          rq.appointments[0].schedule <= cal_endschedule
        );
      });
      return {
        requeriments,
        total: requeriments.reduce(
          (prev, rq) => prev + rq.appointments.length,
          0
        ),
        assigned: requeriments.filter(rq => rq.truck_id)
      };
    },
    getAppointments() {
      this.loading = true;
      api
        .post("/get_appointments", {
          port_id: this.port.id,
          service_type_code: this.serviceSelected,
          start_date: moment(this.startDay).format("YYYY-MM-DD 00:00:00"),
          end_date: moment(this.endDay).format("YYYY-MM-DD 23:59:59")
        })
        .then(response => {
          this.loading = false;
          this.requeriments = response.requeriments;
        });
    },
    displayAppointments(requeriments, day, hour) {
      this.showAppointments = true;

      let schedule_start = `${day.format("YYYY-MM-DD")} ${hour.format(
        "HH:00:00"
      )}`;
      let schedule_end = `${day.format("YYYY-MM-DD")} ${hour.format(
        "HH:59:59"
      )}`;
      this.appointment_startdate = moment(schedule_start).format(
        "YYYY-MM-DD HH:00:00"
      );
      this.appointment_enddate = moment(schedule_end).format(
        "YYYY-MM-DD HH:59:59"
      );
      this.edit_requeriments = requeriments;
    },
    hasPortages(day, hour) {
      let schedule_start = `${day.format("YYYY-MM-DD")} ${hour.format(
        "HH:00:00"
      )}`;
      // let schedule_end = `${day.format('YYYY-MM-DD')} ${hour.format('HH:59:59')}`
      let schedule = moment(schedule_start).format("YYYY-MM-DD HH:00:00");
      // this.appointment_enddate = moment(schedule_end).format('YYYY-MM-DD HH:59:59')

      let portages = this.portages.filter(portage => {
        let condition = true;
        if (this.serviceSelected === "EXPO") {
          condition =
            schedule >= portage.stacking && schedule <= portage.cutoff;
        } else if (this.serviceSelected === "IMPO") {
          condition = schedule >= portage.td && schedule <= portage.cutoff;
        }
        return condition;
      });
      return portages.length;
    },
    schedule() {
      this.showModalAssignment = true;
    },
    makeAssignment(data) {
      this.loading = true;
      api
        .post("/portage_schedule_assignment", {
          ...data,
          portCode: this.port.code,
          operation: this.serviceSelected
        })
        .then(response => {
          this.loading = false;
          const { assignments } = response;
          assignments.map(assg => {
            let index = this.requeriments.findIndex(r => r.id === assg.rq);
            if (index >= 0) {
              const newRq = { ...this.requeriments[index] };
              newRq.truck = assg.truck;
              newRq.truck_id = assg.truck.id;
              this.requeriments.splice(index, 1, newRq);
            }
          });
          this.showSuccess(
            `Se asignó correctamente las ${assignments.length} citas.`,
            "Asignación"
          );
        })
        .catch(err =>
          this.showWarning("No se puedo realizar la asignación.", "Asignación")
        );
    }
  },
  sockets: {
    connect() {
      console.log("conectado");
    },
    updatePortageTrucks() {
      this.getTrucks();
    },
    addAppointment(data) {
      console.log(data);
      data.map(elem => {
        console.log(elem);
        let index = this.requeriments.findIndex(rq => rq.id === elem.id);
        if (index < 0) {
          console.log("new");
          this.requeriments.push(elem);
        } else {
          console.log("update");
          this.requeriments.splice(index, 1, elem);
        }
      });
    },
    updateAppointment(data) {
      let index = this.requeriments.findIndex(rq => rq.id === data.id);
      if (index >= 0) {
        this.requeriments.splice(index, 1, data);
      }
    },
    removeAppointment(requeriment_id) {
      let index = this.requeriments.findIndex(rq => rq.id === requeriment_id);
      if (index >= 0) {
        this.requeriments.splice(index, 1);
      }
    },
    updateRequeriment: function(rq) {
      let index = this.requeriments.findIndex(req => req.id === rq.id);
      if (index >= 0) {
        this.requeriments.splice(index, 1, rq)
      }
    }
  }
};
</script>

<style scoped>
.table thead tr th {
  text-align: center;
}
.table tbody tr td {
  text-align: center;
}
</style>


